import { logger as log } from '@common/logger';
import { vappContainer } from '@/application';
import { SignInPageService } from '@/pages/SignIn';
import { StorageModule } from '@vlinder-web/storage-module-react';

import toast from 'react-hot-toast';
import { AppNavigatorService } from '@/AppNavigator';
const MODULE_NAME = 'profile.machines.states.signInUser';

const getSrv = () => {
  return vappContainer.get<SignInPageService>(SignInPageService.displayName);
};

const getAppSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};
export const validateEmail = (context: any, event: any) => {
  const method = 'signIn';
  return new Promise((resolve, reject) => {
    const run = async () => {
      try {
        const srv = getSrv();
        const content = await srv.validateEmail(event?.payload);
        console.log(`validateEmail response:`, content);

        if (content === 'LOGIN') {
          console.log(`validateEmail response:`, content);
          resolve({ type: 'LOGIN', value: content });
        } else if (content === 'ACCOUNT') {
          console.log(`validateEmail response:`, content);
          resolve({ type: 'ACCOUNT', value: content });
        } else if (content === 'PASSWORD') {
          console.log(`validateEmail response:`, content);
          resolve({ type: 'PASSWORD', value: content });
        } else {
          const msg = content?.error || 'Unknown error';
          toast.error(msg);
          reject({ type: 'ERROR', value: content });
        }
      } catch (err: any) {
        const _msg = err?.message || 'Unknown error';
        toast.error(_msg);
        reject({ type: 'ERROR', value: _msg });
      }
    };

    run();
  });
};
